module.exports = __webpack_public_path__ + "static/media/medal-badge-icon.382f6b05.svg";